'use client'
import { useHasScrolled } from '@/hooks/use-has-scrolled'
import { cn } from '@/lib/css-utils'

export function TopNavContainer({
  children,
  className,
}: {
  children: React.ReactNode
  className?: string
}) {
  const { hasScrolled } = useHasScrolled()

  return (
    <nav
      className={cn(
        'justify-center items-center px-default pt-3 pb-2 bg-topNav-bg flex sticky top-0 z-50',
        className,
        hasScrolled && 'shadow-md',
      )}
      // https://www.notion.so/marithealth/Editing-profile-causes-console-error-1ad1ff33e27480ecae27d69694ab2763?pvs=4
      // see comments for why aria-hidden="false" is needed
      aria-hidden="false"
    >
      {children}
    </nav>
  )
}
